//import React, { useEffect } from 'react';
//import { Box } from '@mui/material';
//import VendorHeader from './Front/VendorHeader';
//import VendorFilterBar from './Front/VendorFilterBar';
// import VendorKpis from './Front/VendorKpis';
// import POStatusCard from './Front/POStatusCard';
// import PerformanceTrendCard from './Front/PerformanceTrendCard';
// import InvoiceStatusCard from './Front/InvoiceStatusCard';
// import PaymentCenterCard from './Front/PaymentCenterCard';
// import ActionCenterCard from './Front/ActionCenterCard';
// import UpcomingDeliveriesCard from './Front/UpcomingDeliveriesCard';
// import PurchaseOrdersCard from './Front/PurchaseOrdersCard';
// import VendorDetailDrilldown from './Drilldown/VendorDetailDrilldown';

// import '../../../styles/global.css';

// import { initBaseDashboard } from '../../../globalData';

// export default function VendorView() {
//   //   useEffect(() => {
//   //   initBaseDashboard();
//   // }, []);

//   return (

//     //<Box>HI </Box>
//     <Box className="page active" id="page-vendor">
//       <VendorHeader />
//       <VendorFilterBar />
//       <VendorKpis />
//       <VendorDetailDrilldown />

//       <Box className="grid-2">
//         <POStatusCard />
//         <PerformanceTrendCard />
//       </Box>

//       <InvoiceStatusCard />

//       <Box className="grid-2b">
//         <PaymentCenterCard />
//         <ActionCenterCard />
//       </Box>

//       <UpcomingDeliveriesCard />
//       <PurchaseOrdersCard />
//     </Box>
//   );
// }





import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import VendorHeader from './Front/VendorHeader';
import VendorFilterBar from './Front/VendorFilterBar';
import VendorKpis from './Front/VendorKpis';
import POStatusCard from './Front/POStatusCard';
import PerformanceTrendCard from './Front/PerformanceTrendCard';
import InvoiceStatusCard from './Front/InvoiceStatusCard';
import PaymentCenterCard from './Front/PaymentCenterCard';
import ActionCenterCard from './Front/ActionCenterCard';
import UpcomingDeliveriesCard from './Front/UpcomingDeliveriesCard';
import PurchaseOrdersCard from './Front/PurchaseOrdersCard';
import VendorDetailDrilldown from './Drilldown/VendorDetailDrilldown';

import '../../../styles/global.css';

import Service from '../../../Services/Service';

export default function VendorView() {

  const [dashboardDivs, setDashboardDivs] = useState([]);

 useEffect(() => {

  // ---------------------------------------------------
  // Logged-in user details
  // ---------------------------------------------------

  const groupID = sessionStorage.getItem("GroupId");
  const empNo = sessionStorage.getItem("EmpNo");

  console.log("Vendor GroupID:", groupID);
  console.log("Vendor EmpNo:", empNo);

  // ---------------------------------------------------
  // Get menus already loaded by Sidebar
  // ---------------------------------------------------

  const allMenus = JSON.parse(
    sessionStorage.getItem("ALL_MENUS") || "[]"
  );

  console.log("ALL_MENUS:", allMenus);

  // ---------------------------------------------------
  // Find Vendor menu
  // ---------------------------------------------------

  const vendorMenu = allMenus.find(
    (menu) =>
      menu.form === "/VendorView" ||
      menu.Form === "/VendorView" ||
      menu.menuText === "Vendor" ||
      menu.MenuText === "Vendor"
  );

  if (!vendorMenu) {
    console.error("Vendor menu not found in ALL_MENUS.");
    setDashboardDivs([]);
    return;
  }

  // ---------------------------------------------------
  // Get Vendor MenuID dynamically
  // ---------------------------------------------------

  const menuID =
    vendorMenu.mnuId ??
    vendorMenu.MnuId;

  console.log("Vendor MenuID:", menuID);

  // ---------------------------------------------------
  // Validate
  // ---------------------------------------------------

  if (!empNo || !menuID) {
    console.error(
      "EmpNo or Vendor MenuID is missing."
    );

    setDashboardDivs([]);
    return;
  }

  // ---------------------------------------------------
  // Dashboard API
  // ---------------------------------------------------

  Service.setApiUrl(
    sessionStorage.getItem("APIUrl") +
    "/api/DashBoard"
  );

  // ---------------------------------------------------
  // Get dashboard permissions for logged-in employee
  // ---------------------------------------------------

  Service.getDashboardDivAccessByEmpNo(
    groupID,
    empNo,
    menuID
  )
    .then((res) => {

      console.log(
        "Employee Dashboard Div Access:",
        res.data
      );

      setDashboardDivs(
        res.data || []
      );

    })
    .catch((err) => {

      console.error(
        "Employee Dashboard Div Access Error:",
        err
      );

      setDashboardDivs([]);

    });

}, []);
  // =====================================================
  // Helper
  // =====================================================

  const hasAccess = (divKey) => {

    return dashboardDivs.some(
      (d) =>
        d.divKey === divKey &&
        (
          d.accessValue === true ||
          d.accessValue === 1 ||
          d.accessValue === "1"
        )
    );

  };


  return (

    <Box
      className="page active"
      id="page-vendor"
    >

      {/* ================================================
          Vendor Header
          ================================================ */}
      {hasAccess("VendorHeader") && (
        <VendorHeader />
      )}


      {/* ================================================
          Vendor Filter Bar
          ================================================ */}
      {hasAccess("VendorFilterBar") && (
        <VendorFilterBar />
      )}


      {/* ================================================
          Vendor KPIs
          ================================================ */}
      {hasAccess("VendorKpis") && (
        <VendorKpis />
      )}


      {/* ================================================
          Vendor Detail Drilldown
          ================================================ */}
      {hasAccess("VendorDetailDrilldown") && (
        <VendorDetailDrilldown />
      )}


      {/* ================================================
          PO Status + Performance Trend
          ================================================ */}
      <Box className="grid-2">

        {hasAccess("POStatusCard") && (
          <POStatusCard />
        )}

        {hasAccess("PerformanceTrendCard") && (
          <PerformanceTrendCard />
        )}

      </Box>


      {/* ================================================
          Invoice Status
          ================================================ */}
      {hasAccess("InvoiceStatusCard") && (
        <InvoiceStatusCard />
      )}


      {/* ================================================
          Payment + Action Center
          ================================================ */}
      <Box className="grid-2b">

        {hasAccess("PaymentCenterCard") && (
          <PaymentCenterCard />
        )}

        {hasAccess("ActionCenterCard") && (
          <ActionCenterCard />
        )}

      </Box>


      {/* ================================================
          Upcoming Deliveries
          ================================================ */}
      {hasAccess("UpcomingDeliveriesCard") && (
        <UpcomingDeliveriesCard />
      )}


      {/* ================================================
          Purchase Orders
          ================================================ */}
      {hasAccess("PurchaseOrdersCard") && (
        <PurchaseOrdersCard />
      )}

    </Box>

  );
}